import React, { Component } from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'
import ReactPasswordStrength from 'react-password-strength'
import createAxios from 'utils/axios'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

class NewPasswordForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      passwordIsValid: false,
      errors: [],
      sent: false,
      newPassword: '',
      newPasswordConfirmation: '',
    }
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  validate() {
    const errors = []

    if (this.state.newPassword.length > 0 && this.state.newPassword !== this.state.newPasswordConfirmation) {
      errors.push(this.t('ForgotPassword.PasswordsDoesNotMatch'))
    }

    if (!this.state.passwordIsValid) {
      errors.push(this.t('ForgotPassword.PasswordAreTooWeak'))
    }

    this.setState({ errors: errors })
    return errors.length === 0
  }

  handleSubmit(e) {
    e.preventDefault()
    const valid = this.validate()

    if (!valid) {
      return
    }

    this.setState({ fetching: true })

    const url = '/set_new_password'
    const payload = {
      recovery_token: this.props.recoveryToken,
      new_password: this.state.newPassword
    }

    this.axios.post(url, payload).then(({ data }) => {
      if (data === true) {
        this.setState({ sent: true })
      } else {
        this.setState({ errors: [ this.t('ForgotPassword.UnableToChangePassword') ] })
      }

      this.setState({ fetching: false })
    })
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handlePasswordChange(state) {
    this.setState({ passwordIsValid: state.isValid, newPassword: state.password })
  }

  render() {
    const scoreWords = ['weak', 'okay', 'good', 'strong', 'stronger'].map(word => {
      return this.t(`ForgotPassword.ScoreWord-${word}`)
    })

    const errors = this.state.errors.map((error, i) => {
      return <div key={i} className="error">{error}</div>
    })

    if (this.state.sent) {
      return (
        <div>
          <h4><FormattedMessage id="ForgotPassword.PasswordChanged" /></h4>
          <a href={this.link('/login')} className='button button-dark-blue'>
            <FormattedMessage id="ForgotPassword.BackToLogin" />
          </a>
        </div>
      )
    }

    return (
      <form onSubmit={this.handleSubmit.bind(this)} className="form">
        <div className="form-group">
          <p><FormattedMessage id="ForgotPassword.EnterNewPassword" /></p>

          {errors.length > 0 && <ol className="error-messages">{errors}</ol>}

          <div className="form-group">
            <ReactPasswordStrength
              minLength={6}
              minScore={1}
              scoreWords={scoreWords}
              changeCallback={this.handlePasswordChange.bind(this)}
              inputProps={{
                name: 'newPassword',
                value: this.state.newPassword,
                autoFocus: true,
                placeholder: this.t('ForgotPassword.NewPassword')
              }}
            />
          </div>

          <div className="form-group">
            <input
              name="newPasswordConfirmation"
              value={this.state.newPasswordConfirmation}
              onChange={(e) => this.handleChange(e)}
              type="password"
              placeholder={this.t('ForgotPassword.NewPasswordConfirmation')} />
          </div>
        </div>

        <div className="form__message">
          {errors.length > 0 && <div>{errors}</div>}

          {this.state.fetching &&
            <div className="wrapper">
              <div className="cssload-loader"></div>
            </div>
          }
        </div>

        <input
          type="submit"
          className="button button-dark-blue"
          value={this.t('ForgotPassword.ChangePassword')} />

      </form>
    )
  }
}

export default injectIntl(NewPasswordForm)



// WEBPACK FOOTER //
// ./app/javascript/components/application/forgot_password/new_password_form.js